import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Input, Space, Button, InputNumber, Checkbox, Select, Radio } from "antd";
import { useParams } from 'react-router-dom';
import useGetApi from '../../services/useGetApi';
import usePost from '../../services/usePost';

const AddnewQuizQuestion = ({ 
    setAddQuizQuestion, quizSectionId, 
    quizId, mode, editQuizId, setAddQuestion, getQuizQuestions,
    setEditQuizId
}) => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const [questionType, setQuestionType] = useState('');
  const [numOfOptions, setNumOfOptions] = useState(0);
  const [options, setOptions] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [validAnswers,setValidAnswers] = useState(false)


  const [question, setQuestion] = useState({
    quizId: '',
    question: '',
    questionType: '',
    options: [],
    answer: []
  });

  const [
    editquizQuestionIsLoading,
    editquizQuestionError,
    editquizQuestions,
    editgetQuizQuestions,
  ] = useGetApi(`sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/question/${editQuizId}`, [], true);

  const [isPostLoading, postError, postData] = usePost();

  // Helper function to reset the question state
  const resetQuestionState = () => {
    setQuestion({
      quizId: '',
      question: '',
      questionType: '',
      options: [],
      answer: [],
    });
    setOptions([]);
    setSelectedAnswers([]);
    setNumOfOptions(0);
    setQuestionType(''); 
    form.resetFields(); 
  };

  // Fetch question details when editing
  useEffect(() => {
    if (mode === 'Add') {
      resetQuestionState(); // Clear all previous data
    } else if (mode === 'Edit' && editQuizId) {
      editgetQuizQuestions(
        `sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/question/${editQuizId}`
      );
    }
  }, [mode, editQuizId]);

  useEffect(() => {
    if (editquizQuestions && mode === 'Edit') {
      try {
        const parsedOptions = editquizQuestions?.options ? JSON.parse(editquizQuestions.options) : [];
        const parsedAnswers = editquizQuestions?.answer ? JSON.parse(editquizQuestions.answer) : [];
        
        setQuestion({
          id: editquizQuestions?.id,
          quizId: editquizQuestions?.quizId,
          question: editquizQuestions?.question,
          questionType: editquizQuestions?.questionType,
          options: parsedOptions,
          answer: parsedAnswers,
        });
  
        setOptions(parsedOptions);
        setSelectedAnswers(parsedAnswers);
        setQuestionType(editquizQuestions?.questionType); 
        setNumOfOptions(parsedOptions?.length); 
  
        form.setFieldsValue({
          question: editquizQuestions?.question,
          questionType: editquizQuestions?.questionType,
          numberOfOptions: parsedOptions?.length,
        });
      } catch (error) {
        console.error("Error parsing JSON data:", error);
      }
    }
  }, [editquizQuestions, mode]); // Only run when edit data changes or mode changes

  // Update numOfOptions when question.options changes
//   useEffect(() => {
//     setNumOfOptions(question?.options?.length);
//     form.setFieldsValue({
//       numberOfOptions: question?.options?.length,
//     });
//   }, [question]);

  // Handle number of options change
  const handleNumberOfOptionsChange = (value) => {
    setNumOfOptions(value);
    const initialOptions = new Array(value).fill('');
    setOptions(question.options.length > 0 ? question.options : initialOptions);
    setSelectedAnswers([]);
  };

  // Handle option input change
  const handleOptionChange = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index] = value;
    setOptions(updatedOptions);
    setQuestion((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  };

  // Handle checkbox change for multiple-choice questions
  const handleCheckboxChange = (index, e) => {
    const isChecked = e.target.checked;
    const updatedAnswers = [...selectedAnswers];

    if (isChecked) {
      updatedAnswers.push(options[index]);
    } else {
      const answerIndex = updatedAnswers.indexOf(options[index]);
      if (answerIndex > -1) {
        updatedAnswers.splice(answerIndex, 1);
      }
    }

    setSelectedAnswers(updatedAnswers);
    setQuestion((prev) => ({
      ...prev,
      answer: updatedAnswers,
    }));
  };

  // Handle radio change for single-choice questions
  const handleRadioChange = (e) => {
    const selectedAnswer = e;
    // console.log(selectedAnswer,'selected')
    setSelectedAnswers([selectedAnswer]);
    setQuestion((prev) => ({
      ...prev,
      answer: [selectedAnswer],
    }));
  };



  // useEffect(() => {
  //   console.log(question,'./././././././.')
  // },[question])

  // useEffect(() => {
  //   console.log(selectedAnswers,'.....')
  // },[selectedAnswers])

  // Handle form submission
  const handleSubmit = async () => {

    if(selectedAnswers.length === 0){
       setValidAnswers(true)
       return
    }
    const dataToSubmit = {
      ...question,
      quizId: quizId,
      options: JSON.stringify(options),
      answer: JSON.stringify(selectedAnswers),
    };


    const response = await postData(
        `sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/question`,
         dataToSubmit, true
    );

    if (response) {
      resetQuestionState();
      setEditQuizId('')
      getQuizQuestions(`sections/course/${id}/section/${quizSectionId}/quiz/${quizId}/questions`);
      setAddQuestion(true);
      setOptions([])
      setSelectedAnswers([])
      form.resetFields() 
    }

  };

  return (
    <div className="popup-overlay">
      <div className="addquiz-question-container p-20" style={{ display: 'flex', flexDirection: 'column' }}>
        <Row gutter={300}>
          <Col>
            <h5>{mode === 'Add' ? 'Add New question' : 'Edit Question'}</h5>
          </Col>
          <Col>
            <button
              className="close-btn"
              onClick={() => {

                resetQuestionState(); 
                setAddQuestion(true); 
                setEditQuizId('');
              }}
            >
              <CloseOutlined />
            </button>
          </Col>
        </Row>
        <Row className="popup_horizontal_line"></Row>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          initialValues={{
            question: question.question,
          }}
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Write your question"
            name="question"
            rules={[{ required: true, message: "Please input the question!" }]}
          >
            <Input
              value={question?.question}
              placeholder="Enter question"
              onChange={(e) => setQuestion({ ...question, question: e.target.value })}
            />
          </Form.Item>

          <Form.Item
            label="Question type"
            name="questionType"
            rules={[{ required: true, message: "Please select the question type!" }]}
          >
            <Select
              showSearch
              placeholder="Select question type"
              optionFilterProp="label"
              onChange={(value) => {
                setQuestion((prev) => ({
                  ...prev,
                  questionType: value,
                }));
                setNumOfOptions(0);
                setQuestion((prev) => ({
                    ...prev,
                    options: [] ,
                    answer: []
                }));
                setSelectedAnswers([])
                setOptions([])
                form.setFieldsValue({
                    'numberOfOptions':0
                });
              }}
              value={questionType}
              options={[
                { value: 'Multiple_choice', label: 'Multiple choice' },
                { value: 'Single_choice_And_true/false', label: 'Single choice And true/false' },
                { value: 'Fill_in_the_blank', label: 'Fill in the blank' },
              ]}
            />
          </Form.Item>


          {question?.questionType !== 'Fill_in_the_blank' && (
            <Form.Item
              label="Number of options"
              name="numberOfOptions"
              rules={[{ required: true, message: "Please input the number of options!" }]}
            >
              <InputNumber
                onChange={handleNumberOfOptionsChange}
                style={{ width: '100%' }}
              />
            </Form.Item>
          )}

 

            {question?.questionType === 'Multiple_choice' && (
              <Form.Item label="Options"
              style={{display:'flex',flexDirection:'column',width:'100%'}}
              rules={[
                {
                  required: true,
                },
              ]}
              >
                <div 
                 style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  marginBottom: '16px', 
                }}
                >
                {Array.from({ length: numOfOptions }, (_, index) => (
                  <Row
                    key={index}
                    // gutter={16}
                    // align="middle"
                    // style={{display:'flex',flexDirection:'column',width:'100%'}}
                    
                  >

                      <Form.Item
                        name={["options", index, "text"]}
                        rules={[
                          {
                            required: true,
                            message: "Please input the option text!",
                          },
                        ]}
                        initialValue={options[index] || '' || ""}
                      >
                        <Input
                          placeholder={`Enter option ${index + 1}`}
                          onChange={(e) => handleOptionChange(index, e.target.value)}
               
                        />
                      </Form.Item>

              
                      <Form.Item
                        name={["options", index, "isCorrect"]}
                        valuePropName="checked"
                        initialValue={selectedAnswers.includes(options[index])}
                      >
                        <Checkbox
                          onChange={(e) => handleCheckboxChange(index, e)}
                        >
                        </Checkbox>
                      </Form.Item>
              
                  </Row>
                ))}
                </div>
              </Form.Item>
            )}

          {question?.questionType === 'Fill_in_the_blank' && (
            <Form.Item
              label="Correct Answer"
              name="fillInBlankAnswer"
              rules={[{ required: true, message: "Please input the correct answer!" }]}  
              style={{ marginTop: '5px' }}
              initialValue={selectedAnswers[0] || '' || ""}
            >
              <Input
                onChange={(e) => setSelectedAnswers([e.target.value])}  
                placeholder="Enter option"
         
              />
            </Form.Item>
          )}


{question?.questionType === 'Single_choice_And_true/false' && (
  <Form.Item
    label="Options"
    name="singleChoiceAnswer"
  >
  
 
          {Array.from({ length: numOfOptions }, (_, index) => (
            <div key={index} 
            style={{display:'flex'}}
            >
              {/* Option Input */}
          
                <Form.Item
                  name={["options", index, "text"]}
                  rules={[{ required: true, message: "Please input option!" }]}
                  initialValue={options[index] || ''} 
                >
                  <Input
                    value={options[index] || ''} 
                    onChange={(e) => handleOptionChange(index, e.target.value)} 
                    placeholder={`Enter option ${index + 1}`}
                    style={{ width: '550px'}}
                  />
                </Form.Item>
    
                    <Radio.Group
                      value={selectedAnswers[0]} 
                      onChange={(e) => handleRadioChange(e.target.value)} 
                      rules={[{ required: true, message: "Please select one correct answer!" }]}
                    >
                      <Radio
                       style={{marginLeft:'20px',marginTop:'5px'}}
                        value={options[index]} 
                      >
      
                      </Radio>
                  </Radio.Group>
            </div>
          ))}

  </Form.Item>
)}
        
        {validAnswers && <p className='warning'>please mark answer!!</p>}

          <Form.Item>
            <Space>
              <Row justify="end" className="submit_btn_div">
                <button
                  className="popup_submit_btn"
                  htmlType='submit'
                >
                  Submit
                </button>
              </Row>
            </Space>
          </Form.Item>
        </Form>

      </div>
    </div>
  );
};

export default AddnewQuizQuestion;